import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

/**
 * Compact right-side node editor — stays beside the canvas, not full-screen.
 */
const FlowNodeEditorShell = ({
  open,
  onClose,
  title,
  subtitle,
  icon: Icon,
  accent,
  children,
}) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const chip = accent?.chip || "bg-green-100 text-green-800";
  const iconCls = accent?.icon || "text-green-700";

  return createPortal(
    <>
      <button
        type="button"
        className="ping-drawer-backdrop fb-node-backdrop"
        aria-label="Close node editor"
        onClick={onClose}
      />
      <aside className="ping-drawer fb-node-drawer" role="dialog" aria-label={title || "Node editor"}>
        <header className="ping-drawer-head">
          <div className="fb-node-title">
            {Icon && (
              <div className={`fb-node-ico ${chip}`}>
                <Icon size={16} className={iconCls} />
              </div>
            )}
            <div className="min-w-0">
              <h3>{title}</h3>
              {subtitle && <p>{subtitle}</p>}
            </div>
          </div>
          <button type="button" className="camp-ico" onClick={onClose} title="Close" aria-label="Close">
            <X size={16} />
          </button>
        </header>
        <div className="ping-drawer-body fb-node-body">{children}</div>
      </aside>
    </>,
    document.body
  );
};

export default FlowNodeEditorShell;
